import { styled } from "@mui/material";

export const LogoImg = styled("img", { label: "ManufacturerLogo-LogoImg" })(
  ({ theme }) => ({
    width: 100,
    height: 'fit-content',
    
  })
);
